var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-credit-cta-line"},[_c('div',{staticClass:"c-credit-cta-line__inner"},[_c('shared-tips-line',{attrs:{"is-vertical":true,"is-center-overwrite":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }